import React, { useEffect } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import { fetchAssets } from "src/actions/community/assetsActions";
import { useAppDispatch } from "src/store/hooks";
import { queryParams } from "src/helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Assets/_partials/_PageHeader";
import List from "../Assets/_partials/_List";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";
import { fetchCategories } from "src/actions/community/categoriesActions";
import NavBarThree from "src/componets/NavBarThree";
import { PlusOutlined, InboxOutlined } from "@ant-design/icons";
import { setNewParams, setNewGroupParams } from "src/store/community/assetsSlice";
import MenuCategories from "src/pages/community/Categories/_partials/_MenuCategories";
import NewCategory from "src/pages/community/Categories/New";
import EditCategory from "src/pages/community/Categories/Edit";
import CategoriesSettings from "src/pages/community/Categories/Settings";
import New from "./New";
import Dropzone from "./Dropzone";

const LIMIT = 42;
const TARGET = 'assets';

const Assets = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const categoryId = queryParams.getInt(searchParams,'category_id');
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { app_id } = useParams();

  useEffect(() => {
    dispatch(fetchCategories({ params: { app_id: app_id, target: TARGET } }));
  }, [app_id, dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: app_id,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT,
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(fetchAssets({ params }));
  }, [categoryId, app_id, searchParams, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { app_id: app_id };

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(setNewParams(params));
  }

  function onClickGroupCreate() {
    const params: any = { app_id: app_id };

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(setNewGroupParams(params));
  }

  return (
    <PageLayout>
      <PageHeader
        title={'Assets'}
      />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Asset
          </NavBarThree.Button>

          <NavBarThree.Button className='v-link2' onClick={onClickGroupCreate}>
            <InboxOutlined /> Assets Dropzone
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            search
            orderBy={
              {
                defaultKey: 'id',
                defaultSort: 'desc',
                items: [{ name: 'Date', key: 'id' }]
              }
            }
          >
            <MenuCategories />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} />

        <New />
        <Dropzone />

        <NewCategory />
        <EditCategory />
        <CategoriesSettings />
      </div>
    </PageLayout>
  );
}

export default Assets;
